import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class ContactService {
  constructor(private restService: RestService) { }

  getSellerModuleContacts(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  saveContact(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  deleteContact(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getPoolSellerModuleContacts(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ChatViewDealForBuyer(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ChatViewDealForseller(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ChatViewDealPoolsForBuyer(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ChatViewDealPoolsForseller(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ChatViewDealsGroupForseller(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ChatViewDealsGroupForBuyer(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  InvitedBuyersForDealGroup(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  InvitedSellersForDealGroup(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
}